import {httpRequest} from '../config/axios';
import {setMongoConfig} from '../constants/config';

const getMongoConfig = async () => {
  try {
    const response = await httpRequest.get('/get-config-mongo?key=FRONTEND_CONFIG');
    setMongoConfig(response?.data?.data?.data);
  } catch (error) {
    console.log(error);
  }
};

export {getMongoConfig};
